import React, { useState } from "react";
import axios from "axios";
import { useNavigate, useLocation } from "react-router-dom";
import { motion } from "framer-motion";
import styled from "styled-components";
import { FaLock } from "react-icons/fa";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import backImage from "./assets/back.jpg";
import logo from "./assets/Logo2.png";

const Container = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
  background-image: url(${backImage});
  background-size: cover;
  background-position: center;
`;

const Form = styled(motion.form)`
  font-family: "Inter", sans-serif;
  background: rgba(48, 136, 139, 0.15); /* Glass effect */
  backdrop-filter: blur(12px);
  padding: 40px;
  border-radius: 16px;
  box-shadow: 0px 8px 32px rgba(0, 0, 0, 0.2);
  width: 100%;
  max-width: 500px;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
`;

const Logo = styled.img`
  width: 200px;
  margin-bottom: 20px;
`;

const InputField = styled.div`
  margin-bottom: 20px;
  position: relative;
  width: 100%;

  input {
    width: 100%;
    padding: 12px 50px;
    border: none;
    border-radius: 8px;
    font-size: 16px;
    font-weight: bold;
    color: #333;
    background: rgba(255, 255, 255, 0.2);
    backdrop-filter: blur(5px);
    outline: none;
    transition: all 0.3s ease-in-out;

    &:focus {
      background: rgba(255, 255, 255, 0.3);
      box-shadow: 0px 0px 12px rgba(255, 255, 255, 0.4);
    }

    &::placeholder {
      font-weight: normal;
      color: rgba(46, 42, 42, 0.7);
    }
  }

  svg {
    position: absolute;
    top: 50%;
    left: 15px;
    transform: translateY(-50%);
    color: rgba(46, 42, 42, 0.7);
  }
`;

const Button = styled(motion.button)`
  background: linear-gradient(135deg, #4facfe 0%, #00f2fe 100%);
  color: white;
  padding: 12px;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  font-size: 16px;
  font-weight: 600;
  width: 100%;
  transition: all 0.3s ease-in-out;

  &:hover {
    background: linear-gradient(135deg, #00f2fe 0%, #4facfe 100%);
    transform: scale(1.05);
  }
`;

function ResetPassword() {
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const navigate = useNavigate();
  const location = useLocation();
  const token = new URLSearchParams(location.search).get("token");

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (password !== confirmPassword) {
      toast.error("Hasła się nie zgadzają!");
      return;
    }

    try {
      await axios.post("https://server229256.nazwa.pl/reset-password", {
        token,
        newPassword: password,
      });

      toast.success("Hasło zostało pomyślnie zmienione!");
      setTimeout(() => navigate("/login"), 3000);
    } catch (error) {
      toast.error(error.response?.data?.message || "Błąd resetowania hasła.");
    }
  };

  return (
    <Container>
      <ToastContainer />
      <Form initial={{ opacity: 0 }} animate={{ opacity: 1 }}>
        <Logo src={logo} alt="Logo" />
        <h2>Wprowadź nowe hasło</h2>
        <InputField>
          <FaLock />
          <input
            type="password"
            placeholder="Nowe hasło"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
          />
        </InputField>
        <InputField>
          <FaLock />
          <input
            type="password"
            placeholder="Potwierdź nowe hasło"
            value={confirmPassword}
            onChange={(e) => setConfirmPassword(e.target.value)}
            required
          />
        </InputField>
        <Button type="submit" whileTap={{ scale: 0.95 }} onClick={handleSubmit}>
          Resetuj hasło
        </Button>
      </Form>
    </Container>
  );
}

export default ResetPassword;
